
<template>
    <div class="bg-b">
        <div class="container">
            <div class="actualizacion" v-html="documentContent"></div>
            <div class="button-container">
                <el-button class="custom-button" style="margin-bottom:20px" type="primary" size="large" @click="$router.push({ name: 'home' })">
                    <i class="el-icon-back"></i>  Regresar al listado
                </el-button>
                <br>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            documentContent: ''
        };
    },
    mounted() {
        const documentId = '1HuqCDYk1Xsp7kBiILMWUBXol7e7wpdCcCCafkwm5v7U'; // Reemplaza con el ID de tu documento

        // URL para obtener el contenido en formato HTMLhttps://docs.google.com/document/d/1HuqCDYk1Xsp7kBiILMWUBXol7e7wpdCcCCafkwm5v7U/edit?usp=sharing
        const documentUrl = `https://docs.google.com/document/d/${documentId}/export?format=html`;

        axios.get(documentUrl)
            .then(response => {
                this.documentContent = response.data;
            })
            .catch(error => {
                console.error('Error al obtener el documento:', error);
            });
    }
};
</script>
<style>
.actualizacion{
    /* height: calc(100vh - 350px); */
    background: #FFF;
    padding:20px;
}

.button-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.custom-button {
    font-size: 18px; 
    padding: 12px 24px; 
    border: 2px solid white !important; 
}
</style>
